import styled, { css } from 'styled-components';

interface IContainer {
  isLoading?: boolean;
}

export const Container = styled.div<IContainer>`
  height: 160px;
  width: 100%;
  margin-bottom: 30px;
  border-radius: 20px;
  background: var(--white);
  border: 1px solid var(--gray-e);
  position: relative;

  display: grid;
  grid-template-columns: 1fr 240px;

  filter: drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.1));
  cursor: pointer;

  ${props =>
    props.isLoading &&
    css`
      opacity: 0.5;
      cursor: progress;
    `}

  .info {
    padding: 24px 32px;

    display: flex;
    flex-direction: column;
    justify-content: center;

    p {
      font-size: 14px;
      font-weight: 500;
      color: var(--gray-9);
    }

    h3 {
      font-size: 20px;
      color: var(--primary);
      margin-top: 4px;
      display: flex;
      align-items: center;
      line-height: 120%;

      > svg {
        min-width: 20px;
        margin-right: 8px;
      }
    }
  }

  .image {
    width: 100%;
    height: 100%;
    max-height: 160px;

    padding: 8px;

    .property-image {
      height: 100%;
      width: 100%;
      border-radius: 16px;
      object-fit: cover;
      background-color: var(--gray-d);
    }
  }

  @media (max-width: 1000px) {
    grid-template-columns: 1fr 160px;

    .info {
      padding: 16px 24px;

      p {
        font-size: 12px;
      }

      h3 {
        font-size: 16px;
      }
    }
  }
`;

export const SpinWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const Badge = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 8px;

  > img {
    height: 20px;
    width: 20px;
    min-width: 20px;
    border-radius: 50%;
    background: var(--gray-e);
    margin-right: 8px;
  }

  > p {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 120%;
    margin-top: 2px;
  }
`;
